export interface SortFilterOption {
  value: server.dto.CompanySort
  label: string
  enabled: boolean
}

export interface CompanySortFilterType {
  sortOption: SortFilterOption
}

export const CompanySortOptions: SortFilterOption[] = [
  {
    value: "name_asc",
    label: RESX.GeneralLabels.Name,
    enabled: true
  },
  {
    value: "status_asc",
    label: RESX.Status.resxStatus,
    enabled: true
  },
  {
    value: "postalcode_asc",
    label: RESX.Address.PostalCode,
    enabled: true
  },
  {
    value: "city_asc",
    label: RESX.Address.City,
    enabled: true
  },
  {
    value: "lastmodified_desc",
    label: RESX.GeneralLabels.LastModified,
    enabled: true
  },
  {
    value: "isvalidated_asc",
    label: RESX.Planning.NotYetChecked,
    enabled: true
  }
];

export const DefaultCompanySortFilter: server.dto.CompanySort = "name_asc";

export const getSortOption = (value: server.dto.CompanySort) => {
  if (value === "unknown") return CompanySortOptions[0];
  return CompanySortOptions.find((s) => s.value === value);
};

export const initialCompanySortFilter: CompanySortFilterType = {
  sortOption: getSortOption(DefaultCompanySortFilter)
};
